<template>
    <div class="border-red-700 bg-red-600 mt-2 rounded border-2 p-4 text-white">
        <div class="text-lg font-bold">
            {{ warningText }}
        </div>

        <div class="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
            <div>
                <label
                    for="fake-payment-source-first-name"
                    class="mb-1 block font-semibold"
                >
                    {{ t('customerInformation.firstName') }}
                </label>
                <input-text
                    id="fake-payment-source-first-name"
                    v-model="firstName"
                    class="w-full"
                    :placeholder="t('customerInformation.firstName')"
                    :disabled="isProcessing"
                />
            </div>

            <div>
                <label
                    for="fake-payment-source-last-name"
                    class="mb-1 block font-semibold"
                >
                    {{ t('customerInformation.lastName') }}
                </label>
                <input-text
                    id="fake-payment-source-last-name"
                    v-model="lastName"
                    class="w-full"
                    :placeholder="t('customerInformation.lastName')"
                    :disabled="isProcessing"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import InputText from 'primevue/inputtext'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCheckoutFormProcessing } from '~/components/Checkout/Forms/use-checkout-form'
import type { TokenPaymentMethod } from '~/components/Checkout/Sections/Payment/payment-method'

const props = defineProps<{
    displayName: string
    warningText: string
}>()

const emit = defineEmits<{
    (e: 'paymentMethod', payload: TokenPaymentMethod | undefined): void
}>()

const { t } = useI18n({ useScope: 'global' })
const { isProcessing } = useCheckoutFormProcessing()

const firstName = ref('')
const lastName = ref('')

function buildPaymentMethod(): TokenPaymentMethod | undefined {
    const reference = [firstName.value, lastName.value]
        .map(value => value.trim().replace(/\|/g, ' '))
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()

    if (
        reference === '' ||
        firstName.value.trim() === '' ||
        lastName.value.trim() === ''
    ) {
        return undefined
    }

    // The backend custom token parser uses pipe-delimited storage, so keep names out of that delimiter.
    return {
        type: 'TokenPaymentMethod',
        token: `CUSTOM|1|${reference}`,
        isCard: false,
        paymentTodayAllowed: true,
        brand: props.displayName,
        lastFour: null,
        accountExpirationDate: null
    }
}

function emitPaymentMethod(): void {
    emit('paymentMethod', buildPaymentMethod())
}

watch([firstName, lastName], emitPaymentMethod)

function submitFakePaymentSourceForm(): void {
    emitPaymentMethod()
}

defineExpose({
    submitFakePaymentSourceForm
})
</script>
